import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';

const featuredStocks = [
  { symbol: 'NVDA', name: 'NVIDIA', ticker: 'sNVDA', color: '#76B900' },
  { symbol: 'AAPL', name: 'Apple', ticker: 'sAAPL', color: '#A2AAAD' },
  { symbol: 'TSLA', name: 'Tesla', ticker: 'sTSLA', color: '#E31937' },
  { symbol: 'MSFT', name: 'Microsoft', ticker: 'sMSFT', color: '#00A4EF' },
  { symbol: 'AMZN', name: 'Amazon', ticker: 'sAMZN', color: '#FF9900' },
  { symbol: 'META', name: 'Meta', ticker: 'sMETA', color: '#0081FB' },
  { symbol: 'GOOGL', name: 'Alphabet', ticker: 'sGOOGL', color: '#4285F4' },
  { symbol: 'NFLX', name: 'Netflix', ticker: 'sNFLX', color: '#E50914' },
  { symbol: 'COIN', name: 'Coinbase', ticker: 'sCOIN', color: '#0052FF' },
  { symbol: 'HOOD', name: 'Robinhood', ticker: 'sHOOD', color: '#00C805' },
  { symbol: 'JPM', name: 'JPMorgan', ticker: 'sJPM', color: '#117ACA' },
  { symbol: 'V', name: 'Visa', ticker: 'sV', color: '#1A1F71' },
];

const StockCard = ({ stock, index }) => {
  const [imageError, setImageError] = useState(false);
  const logoUrl = `https://assets-sir.kraken.com/equities/logos/v1/${stock.symbol}.png?i=kds`;
  
  return (
    <div 
      className="group relative bg-white/[0.03] hover:bg-white/[0.06] border border-white/[0.08] hover:border-purple-500/40 rounded-2xl p-6 transition-all duration-300 hover:scale-[1.02] hover:shadow-xl hover:shadow-purple-500/10 cursor-pointer"
      style={{ animationDelay: `${index * 0.05}s` }}
    >
      {/* Glow effect on hover */}
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-purple-500/0 to-indigo-500/0 group-hover:from-purple-500/5 group-hover:to-indigo-500/5 transition-all duration-300" />
      
      <div className="relative flex flex-col items-center text-center">
        {/* Logo */}
        <div 
          className="w-16 h-16 rounded-full overflow-hidden mb-4 ring-2 ring-white/10 group-hover:ring-purple-500/30 transition-all duration-300"
          style={{ backgroundColor: `${stock.color}15` }}
        >
          {!imageError ? (
            <img 
              src={logoUrl}
              alt={stock.name}
              className="w-full h-full object-cover"
              onError={() => setImageError(true)}
            />
          ) : (
            <div 
              className="w-full h-full flex items-center justify-center text-white font-bold text-xl"
              style={{ backgroundColor: stock.color }}
            >
              {stock.symbol.charAt(0)}
            </div>
          )}
        </div>
        
        {/* Ticker */}
        <span className="text-purple-400 font-mono text-sm mb-1">{stock.ticker}</span>
        
        {/* Company Name */}
        <h3 className="text-white font-semibold text-lg group-hover:text-purple-300 transition-colors">
          {stock.name}
        </h3>
      </div>
    </div>
  );
};

const StockGrid = () => {
  return (
    <section className="py-24 bg-[#0b0014] relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-purple-600/5 rounded-full blur-[150px]" />
      
      <div className="max-w-[1200px] mx-auto px-6 relative">
        <div className="text-center mb-12">
          <p className="text-purple-400 font-medium mb-4">The US stock market onchain</p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white">
            Trade top stocks as tokens
          </h2>
        </div>
        
        {/* Stock Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {featuredStocks.map((stock, index) => (
            <StockCard key={stock.symbol} stock={stock} index={index} />
          ))}
        </div>
        
        {/* CTA */}
        <div className="text-center mt-12">
          <a 
            href="#" 
            className="inline-flex items-center gap-2 px-6 py-3 text-purple-400 hover:text-white border border-purple-500/30 hover:border-purple-500 hover:bg-purple-500/10 rounded-lg transition-all duration-200 group"
          >
            Explore All Products
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default StockGrid;
